export default "__VITE_ASSET__Cf6CXPdu__"